/**
 * Dashboard – no Figma design; placeholder until design is available.
 */
export const Dashboard = () => {
	return (
		<div className="flex min-h-[60vh] flex-col items-center justify-center rounded-2xl border border-border bg-bg-card">
			<p className="text-center text-lg leading-7 text-primary-muted">
				This page is coming soon.
			</p>
		</div>
	);
};
